"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedlineAuthorColorsProvider = void 0;
exports.fetchOrgMemberNames = fetchOrgMemberNames;
exports.readDocumentRedlineAuthors = readDocumentRedlineAuthors;
exports.useApplyRedlineAuthorSides = useApplyRedlineAuthorSides;
var _react = _interopRequireWildcard(require("react"));
var _RedlineAuthorColorsContext = require("@common/components/remedy/RedlineAuthorColorsContext");
var _resourceShares = require("@common/schemas/resource-shares");
var _redlineEngine = require("@common/utils/redline/redline-engine");
var _redlineAuthorColors = require("@common/utils/redlineAuthorColors");
var _useProposalEngineEnabled = require("../hooks/use-proposal-engine-enabled");
var _document = require("../utils/document");
var _envManager = require("../utils/envManager");
var _safeFetch = require("../utils/safe-fetch");
var _AuthContext = require("./AuthContext");
var _WordDocumentContext = require("./WordDocumentContext");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var ApplyRedlineAuthorSidesContext = /*#__PURE__*/(0, _react.createContext)(function () {});
function readDocumentRedlineAuthors() {
  return _readDocumentRedlineAuthors.apply(this, arguments);
}
function _readDocumentRedlineAuthors() {
  _readDocumentRedlineAuthors = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var authorNames, redlineCountByAuthor, _iterator, _step, _redlineCountByAuthor, authorName;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          if (Office.context.requirements.isSetSupported("WordApi", "1.6")) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, []);
        case 1:
          _context2.n = 2;
          return (0, _document.withWordContextRead)(/*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(context) {
              var trackedChanges;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    trackedChanges = context.document.body.getTrackedChanges();
                    trackedChanges.load("items/author");
                    _context.n = 1;
                    return context.sync();
                  case 1:
                    return _context.a(2, trackedChanges.items.map(function (trackedChange) {
                      return trackedChange.author;
                    }));
                }
              }, _callee);
            }));
            return function (_x2) {
              return _ref2.apply(this, arguments);
            };
          }());
        case 2:
          authorNames = _context2.v;
          redlineCountByAuthor = new Map();
          _iterator = _createForOfIteratorHelper(authorNames);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              authorName = _step.value;
              redlineCountByAuthor.set(authorName, ((_redlineCountByAuthor = redlineCountByAuthor.get(authorName)) !== null && _redlineCountByAuthor !== void 0 ? _redlineCountByAuthor : 0) + 1);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return _context2.a(2, _toConsumableArray(redlineCountByAuthor).map(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
              name = _ref4[0],
              redlineCount = _ref4[1];
            return {
              name: name,
              redlineCount: redlineCount
            };
          }));
      }
    }, _callee2);
  }));
  return _readDocumentRedlineAuthors.apply(this, arguments);
}
function fetchOrgMemberNames(_x) {
  return _fetchOrgMemberNames.apply(this, arguments);
}
function _fetchOrgMemberNames() {
  _fetchOrgMemberNames = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(authHeader) {
    var orgUsers, _t;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _t = _resourceShares.ShareUsersSchema;
          _context3.n = 1;
          return (0, _safeFetch.safeFetchJSON)("".concat((0, _envManager.getEnv)("WEBAPP_API_BASE_URL"), "/api/organizations/users"), {
            method: "GET",
            headers: {
              Authorization: authHeader,
              "Content-Type": "application/json"
            }
          });
        case 1:
          orgUsers = _t.parse.call(_t, _context3.v);
          return _context3.a(2, orgUsers.map(function (orgUser) {
            return [orgUser.firstName, orgUser.lastName].filter(Boolean).join(" ");
          }).filter(function (fullName) {
            return fullName.length > 0;
          }));
      }
    }, _callee3);
  }));
  return _fetchOrgMemberNames.apply(this, arguments);
}
var RedlineAuthorColorsProvider = exports.RedlineAuthorColorsProvider = function RedlineAuthorColorsProvider(_ref) {
  var _useProposalEngineAcc;
  var children = _ref.children;
  var currentUserName = (_useProposalEngineAcc = (0, _useProposalEngineEnabled.useProposalEngineAccess)().authorName) !== null && _useProposalEngineAcc !== void 0 ? _useProposalEngineAcc : _redlineEngine.DIOPTRA_AUTHOR;
  var _useWordDocument = (0, _WordDocumentContext.useWordDocument)(),
    documentName = _useWordDocument.documentName,
    documentLocation = _useWordDocument.documentLocation;
  var documentIdentity = "".concat(documentLocation !== null && documentLocation !== void 0 ? documentLocation : "", "/").concat(documentName !== null && documentName !== void 0 ? documentName : "");
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var orgMemberNamesRef = (0, _react.useRef)([]);
  var _useState = (0, _react.useState)(function () {
      return new _redlineAuthorColors.RedlineAuthorColors({
        currentUserName: currentUserName,
        documentAuthors: [],
        isOurSideAuthor: (0, _RedlineAuthorColorsContext.ourSideAuthorRuleFor)([])
      });
    }),
    _useState2 = _slicedToArray(_useState, 2),
    colors = _useState2[0],
    setColors = _useState2[1];
  (0, _react.useEffect)(function () {
    var documentChangedSinceRead = false;
    setColors(new _redlineAuthorColors.RedlineAuthorColors({
      currentUserName: currentUserName,
      documentAuthors: [],
      isOurSideAuthor: (0, _RedlineAuthorColorsContext.ourSideAuthorRuleFor)(orgMemberNamesRef.current)
    }));
    void readDocumentRedlineAuthors().then(function (documentAuthors) {
      if (documentChangedSinceRead) return;
      setColors(new _redlineAuthorColors.RedlineAuthorColors({
        currentUserName: currentUserName,
        documentAuthors: documentAuthors,
        isOurSideAuthor: (0, _RedlineAuthorColorsContext.ourSideAuthorRuleFor)(orgMemberNamesRef.current)
      }));
    }).catch(function (error) {
      return console.warn("Could not read the document's tracked-change authors", error);
    });
    return function () {
      documentChangedSinceRead = true;
    };
  }, [currentUserName, documentIdentity]);
  (0, _react.useEffect)(function () {
    if (!authHeader) return;
    var signedOutSinceFetch = false;
    void fetchOrgMemberNames(authHeader).then(function (orgMemberNames) {
      if (signedOutSinceFetch) return;
      orgMemberNamesRef.current = orgMemberNames;
      setColors(function (current) {
        return current.withOurSideAuthorRule((0, _RedlineAuthorColorsContext.ourSideAuthorRuleFor)(orgMemberNames));
      });
    }).catch(function (error) {
      return console.warn("Could not load the org's members for redline colors", error);
    });
    return function () {
      signedOutSinceFetch = true;
    };
  }, [authHeader]);
  var applyAuthorSides = (0, _react.useCallback)(function (authorSides) {
    setColors(function (current) {
      return current.withAuthorSides(authorSides);
    });
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ApplyRedlineAuthorSidesContext.Provider, {
    value: applyAuthorSides,
    "data-sentry-element": "ApplyRedlineAuthorSidesContext.Provider",
    "data-sentry-component": "RedlineAuthorColorsProvider",
    "data-sentry-source-file": "RedlineAuthorColorsContext.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RedlineAuthorColorsContext.RedlineAuthorColorsValueProvider, {
      colors: colors,
      "data-sentry-element": "RedlineAuthorColorsValueProvider",
      "data-sentry-source-file": "RedlineAuthorColorsContext.tsx",
      children: children
    })
  });
};
function useApplyRedlineAuthorSides() {
  return (0, _react.useContext)(ApplyRedlineAuthorSidesContext);
}